"use strict";
import $ from 'jquery';
import jQuery from 'jquery';

window.$ = $;
window.jQuery = jQuery;
import { Core } from './core.min.js';
import { RdNavBar } from './rdnavbar.js';
import { Popper } from './popper.js';
import { JQueryEventMove } from './jqueryeventmove.js';
import { JQueryResize } from './jqueryresize.js';
import { PointerEvents } from './pointer-events.min.js';
import WOW from '@shared/node_modules/wow.js';




export function INIT() {
	Core();
	PointerEvents();
	JQueryResize();
	JQueryEventMove();
	RdNavBar();
	Popper();


	// Global variables
	let userAgent = navigator.userAgent.toLowerCase(),
		initialDate = new Date(),

		$document = $(document),
		$window = $(window),
		$html = $("html"),
		$body = $("body"),

		isDesktop = $html.hasClass("desktop"),
		isIE = userAgent.indexOf("msie") !== -1 ? parseInt(userAgent.split("msie")[1], 10) : userAgent.indexOf("trident") !== -1 ? 11 : userAgent.indexOf("edge") !== -1 ? 12 : false,
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
		windowReady = false,
		isNoviBuilder = false,
		loaderTimeoutId,

		plugins = {
			bootstrapTooltip: $("[data-toggle='tooltip']"),
			bootstrapModalDialog: $('.modal'),
			bootstrapTabs: $(".tabs-custom"),
			rdNavbar: $(".rd-navbar"),
			materialParallax: $(".parallax-container"),
			rdMailForm: $(".rd-mailform"),
			rdInputLabel: $(".form-label"),
			regula: $("[data-constraints]"),
			selectFilter: $("select"),
			stepper: $("input[type='number']"),
			wow: $(".wow"),
			maps: $('.google-map-container'),
			slick: $('.slick-slider'),
			search: $(".rd-search"),
			searchResults: $('.rd-search-results'),
			statefulButton: $('.btn-stateful'),
			popover: $('[data-toggle="popover"]'),
			viewAnimate: $('.view-animate'),
			radio: $("input[type='radio']"),
			checkbox: $("input[type='checkbox']"),
			customToggle: $("[data-custom-toggle]"),
			counter: $(".counter"),
			progressLinear: document.querySelectorAll('.progress-linear'),
			progressCircle: document.querySelectorAll('.progress-circle'),
			dateCountdown: $('.DateCountdown'),
			preloader: $(".preloader"),
			captcha: $('.recaptcha'),
			scroller: $(".scroll-wrap"),
			mailchimp: $('.mailchimp-mailform'),
			campaignMonitor: $('.campaign-mailform'),
			copyrightYear: $(".copyright-year"),
			layoutToggle: $(".layout-toggle"),
			rdRange: $('.rd-range'),
			radioPanel: $('.radio-panel .radio-inline'),
			multitoggle: document.querySelectorAll('[data-multitoggle]'),
			hoverEls: document.querySelectorAll('[data-hover-group]'),
			vide: $('.bg-vide'),
			videoTriggers: $('[data-video-trigger][data-target]'),
			beforeAfter: $(".twentytwenty-container"),
		};


	/**
	 * @desc Check the element was been scrolled into the view
	 * @param {object} elem - jQuery object
	 * @return {boolean}
	 */
	function isScrolledIntoView(elem) {
		if (isNoviBuilder) return true;
		return elem.offset().top + elem.outerHeight() >= $window.scrollTop() && elem.offset().top <= $window.scrollTop() + $window.height();
	}

	/**
	 * @desc Calls a function when element has been scrolled into the view
	 * @param {object} element - jQuery object
	 * @param {function} func - init function
	 */
	function lazyInit(element, func) {
		let scrollHandler = function () {
			if ((!element.hasClass('lazy-loaded') && (isScrolledIntoView(element)))) {
				func.call();
				element.addClass('lazy-loaded');
			}
		};

		scrollHandler();
		$window.on('scroll', scrollHandler);
	}

	// Initialize scripts that require a loaded window
	$window.on('load', function () {

		// Page loader & Page transition
		if ($(".preloader").length && !isNoviBuilder) {
			pageTransition({
				target: document.querySelector('.page'),
				delay: 0,
				duration: 500,
				classIn: 'fadeIn',
				classOut: 'fadeOut',
				classActive: 'animated',
				conditions: function (event, link) {
					return link && !/(\#|javascript:void\(0\)|callto:|tel:|mailto:|:\/\/)/.test(link) && !event.currentTarget.hasAttribute('data-lightgallery');
				},
				onTransitionStart: function (options) {
					setTimeout(function () {
						$(".preloader").removeClass('loaded');
					}, options.duration * .75);
				},
				onReady: function () {
					$(".preloader").addClass('loaded');
					windowReady = true;
				}
			});
		}

		// Progress Bar
		if (document.querySelectorAll('.progress-linear')) {
			for (var i = 0; i < document.querySelectorAll('.progress-linear').length; i++) {
				var
					container = document.querySelectorAll('.progress-linear')[i],
					counter = aCounter({
						node: container.querySelector('.progress-linear-counter'),
						duration: container.getAttribute('data-duration') || 1000,
						onStart: function () {
							this.custom.bar.style.width = this.params.to + '%';
						}
					});

				counter.custom = {
					container: container,
					bar: container.querySelector('.progress-linear-bar'),
					onScroll: (function () {
						if ((Util.inViewport(this.custom.container) && !this.custom.container.classList.contains('animated')) || isNoviBuilder) {
							this.run();
							this.custom.container.classList.add('animated');
						}
					}).bind(counter),
					onBlur: (function () {
						this.params.to = parseInt(this.params.node.textContent, 10);
						this.run();
					}).bind(counter)
				};

				if (isNoviBuilder) {
					counter.run();
					counter.params.node.addEventListener('blur', counter.custom.onBlur);
				} else {
					counter.custom.onScroll();
					document.addEventListener('scroll', counter.custom.onScroll);
				}
			}
		}

		// Progress Circle
		if (document.querySelectorAll('.progress-circle')) {
			for (var i = 0; i < document.querySelectorAll('.progress-circle').length; i++) {
				var
					container = document.querySelectorAll('.progress-circle')[i],
					counter = aCounter({
						node: container.querySelector('.progress-circle-counter'),
						duration: 500,
						onUpdate: function (value) {
							this.custom.bar.render(value * 3.6);
						}
					});

				counter.params.onComplete = counter.params.onUpdate;

				counter.custom = {
					container: container,
					bar: aProgressCircle({ node: container.querySelector('.progress-circle-bar') }),
					onScroll: (function () {
						if (Util.inViewport(this.custom.container) && !this.custom.container.classList.contains('animated')) {
							this.run();
							this.custom.container.classList.add('animated');
						}
					}).bind(counter),
					onBlur: (function () {
						this.params.to = parseInt(this.params.node.textContent, 10);
						this.run();
					}).bind(counter)
				};

				if (isNoviBuilder) {
					counter.run();
					counter.params.node.addEventListener('blur', counter.custom.onBlur);
				} else {
					counter.custom.onScroll();
					window.addEventListener('scroll', counter.custom.onScroll);
				}
			}
		}
	});

	// Initialize scripts that require a finished document
	$(function () {
		isNoviBuilder = window.xMode;


		/**
		 * @desc Create live search results
		 * @param {object} options
		 */
		function liveSearch(options) {
			$('#' + options.live).removeClass('cleared').html();
			options.current++;
			options.spin.addClass('loading');
			$.get(handler, {
				s: decodeURI(options.term),
				liveSearch: options.live,
				dataType: "html",
				liveCount: options.liveCount,
				filter: options.filter,
				template: options.template
			}, function (data) {
				options.processed++;
				let live = $('#' + options.live);
				if ((options.processed === options.current) && !live.hasClass('cleared')) {
					live.find('> #search-results').removeClass('active');
					live.html(data);
					setTimeout(function () {
						live.find('> #search-results').addClass('active');
					}, 50);
				}
				options.spin.parents('.rd-search').find('.input-group-addon').removeClass('loading');
			});
		}

		/**
		 * @desc Validate google reCaptcha
		 * @param {object} captcha - captcha object for validation
		 * @return {boolean}
		 */
		function validateReCaptcha(captcha) {
			let captchaToken = captcha.find('.g-recaptcha-response').val();

			if (captchaToken.length === 0) {
				captcha
					.siblings('.form-validation')
					.html('Please, prove that you are not robot.')
					.addClass('active');
				captcha
					.closest('.form-wrap')
					.addClass('has-error');

				captcha.on('propertychange', function () {
					let $this = $(this),
						captchaToken = $this.find('.g-recaptcha-response').val();

					if (captchaToken.length > 0) {
						$this
							.closest('.form-wrap')
							.removeClass('has-error');
						$this
							.siblings('.form-validation')
							.removeClass('active')
							.html('');
						$this.off('propertychange');
					}
				});

				return false;
			}

			return true;
		}

		/**
		 * @desc Initialize Google reCaptcha
		 */
		window.onloadCaptchaCallback = function () {
			for (let i = 0; i < plugins.captcha.length; i++) {
				let $capthcaItem = $(plugins.captcha[i]);

				grecaptcha.render(
					$capthcaItem.attr('id'),
					{
						sitekey: $capthcaItem.attr('data-sitekey'),
						size: $capthcaItem.attr('data-size') ? $capthcaItem.attr('data-size') : 'normal',
						theme: $capthcaItem.attr('data-theme') ? $capthcaItem.attr('data-theme') : 'light',
						callback: function (e) {
							$('.recaptcha').trigger('propertychange');
						}
					}
				);
				$capthcaItem.after("<span class='form-validation'></span>");
			}
		};

		/**
		 * @desc Initialize Bootstrap tooltip with required placement
		 * @param {string} tooltipPlacement
		 */
		function initBootstrapTooltip(tooltipPlacement) {
			$("[data-toggle='tooltip']").tooltip('dispose');

			if (window.innerWidth < 576) {
				$("[data-toggle='tooltip']").tooltip({ placement: 'bottom' });
			} else {
				$("[data-toggle='tooltip']").tooltip({ placement: tooltipPlacement });
			}
		}

		/**
		 * @desc Google map function for getting latitude and longitude
		 */
		function getLatLngObject(str, marker, map, callback) {
			let coordinates = {};
			try {
				coordinates = JSON.parse(str);
				callback(new google.maps.LatLng(
					coordinates.lat,
					coordinates.lng
				), marker, map);
			} catch (e) {
				map.geocoder.geocode({ 'address': str }, function (results, status) {
					if (status === google.maps.GeocoderStatus.OK) {
						let latitude = results[0].geometry.location.lat();
						let longitude = results[0].geometry.location.lng();

						callback(new google.maps.LatLng(
							parseFloat(latitude),
							parseFloat(longitude)
						), marker, map);
					}
				});
			}
		}

		/**
		 * @desc Initialize Google maps
		 */
		function initMaps() {
			let key;

			for (let i = 0; i < plugins.maps.length; i++) {
				if (plugins.maps[i].hasAttribute("data-key")) {
					key = plugins.maps[i].getAttribute("data-key");
					break;
				}
			}

			$.getScript('//maps.google.com/maps/api/js?' + (key ? 'key=' + key + '&' : '') + 'libraries=geometry,places&v=quarterly', function () {
				let head = document.getElementsByTagName('head')[0],
					insertBefore = head.insertBefore;

				head.insertBefore = function (newElement, referenceElement) {
					if (newElement.href && newElement.href.indexOf('//fonts.googleapis.com/css?family=Roboto') !== -1 || newElement.innerHTML.indexOf('gm-style') !== -1) {
						return;
					}
					insertBefore.call(head, newElement, referenceElement);
				};
				let geocoder = new google.maps.Geocoder;
				for (let i = 0; i < plugins.maps.length; i++) {
					let zoom = parseInt(plugins.maps[i].getAttribute("data-zoom"), 4) || 5;
					let styles = plugins.maps[i].hasAttribute('data-styles') ? JSON.parse(plugins.maps[i].getAttribute("data-styles")) : [];
					let center = plugins.maps[i].getAttribute("data-center") || "New York";

					// Initialize map
					var map = new google.maps.Map(plugins.maps[i].querySelectorAll(".google-map")[0], {
						zoom: zoom,
						styles: styles,
						scrollwheel: false,
						center: { lat: 0, lng: 0 }
					});

					// Add map object to map node
					plugins.maps[i].map = map;
					plugins.maps[i].geocoder = geocoder;
					plugins.maps[i].keySupported = true;
					plugins.maps[i].google = google;

					// Get Center coordinates from attribute
					getLatLngObject(center, null, plugins.maps[i], function (location, markerElement, mapElement) {
						mapElement.map.setCenter(location);
					});

					// Add markers from google-map-markers array
					let markerItems = plugins.maps[i].querySelectorAll(".google-map-markers li");

					if (markerItems.length) {
						var markers = [];
						for (let j = 0; j < markerItems.length; j++) {
							let markerElement = markerItems[j];
							getLatLngObject(markerElement.getAttribute("data-location"), markerElement, plugins.maps[i], function (location, markerElement, mapElement) {
								let icon = markerElement.getAttribute("data-icon") || mapElement.getAttribute("data-icon");
								let activeIcon = markerElement.getAttribute("data-icon-active") || mapElement.getAttribute("data-icon-active");
								let info = markerElement.getAttribute("data-description") || "";
								let infoWindow = new google.maps.InfoWindow({
									content: info
								});
								markerElement.infoWindow = infoWindow;
								let markerData = {
									position: location,
									map: mapElement.map
								};
								if (icon) {
									markerData.icon = icon;
								}
								let marker = new google.maps.Marker(markerData);
								markerElement.gmarker = marker;
								markers.push({ markerElement: markerElement, infoWindow: infoWindow });
								marker.isActive = false;
								// Handle infoWindow close click
								google.maps.event.addListener(infoWindow, 'closeclick', (function (markerElement, mapElement) {
									let markerIcon = null;
									markerElement.gmarker.isActive = false;
									markerIcon = markerElement.getAttribute("data-icon") || mapElement.getAttribute("data-icon");
									markerElement.gmarker.setIcon(markerIcon);
								}).bind(this, markerElement, mapElement));


								// Set marker active on Click and open infoWindow
								google.maps.event.addListener(marker, 'click', (function (markerElement, mapElement) {
									if (markerElement.infoWindow.getContent().length === 0) return;
									let gMarker, currentMarker = markerElement.gmarker, currentInfoWindow;
									for (let k = 0; k < markers.length; k++) {
										var markerIcon;
										if (markers[k].markerElement === markerElement) {
											currentInfoWindow = markers[k].infoWindow;
										}
										gMarker = markers[k].markerElement.gmarker;
										if (gMarker.isActive && markers[k].markerElement !== markerElement) {
											gMarker.isActive = false;
											markerIcon = markers[k].markerElement.getAttribute("data-icon") || mapElement.getAttribute("data-icon");
											gMarker.setIcon(markerIcon);
											markers[k].infoWindow.close();
										}
									}

									currentMarker.isActive = !currentMarker.isActive;
									if (currentMarker.isActive) {
										if (markerIcon = markerElement.getAttribute("data-icon-active") || mapElement.getAttribute("data-icon-active")) {
											currentMarker.setIcon(markerIcon);
										}

										currentInfoWindow.open(map, marker);
									} else {
										if (markerIcon = markerElement.getAttribute("data-icon") || mapElement.getAttribute("data-icon")) {
											currentMarker.setIcon(markerIcon);
										}
										currentInfoWindow.close();
									}
								}).bind(this, markerElement, mapElement));
							});
						}
					}
				}
			});
		}

		// Google ReCaptcha
		if (plugins.captcha.length) {
			$.getScript("//www.google.com/recaptcha/api.js?onload=onloadCaptchaCallback&render=explicit&hl=en");
		}

		// Additional class on html if mac os.
		if (navigator.platform.match(/(Mac)/i)) {
			$html.addClass("mac-os");
		}

		// Adds some loosing functionality to IE browsers (IE Polyfills)
		if (isIE) {
			if (isIE < 10) {
				$html.addClass("lt-ie-10");
			}

			if (isIE < 11) {
				$.getScript('js/pointer-events.min.js')
					.done(function () {
						$html.addClass("ie-10");
						PointerEventsPolyfill.initialize({});
					});
			}

			if (isIE === 11) {
				$html.addClass("ie-11");
			}

			if (isIE === 12) {
				$html.addClass("ie-edge");
			}
		}

		// Bootstrap Tooltips
		if ($("[data-toggle='tooltip']").length) {
			let tooltipPlacement = $("[data-toggle='tooltip']").attr('data-placement');
			initBootstrapTooltip(tooltipPlacement);

			$window.on('resize orientationchange', function () {
				initBootstrapTooltip(tooltipPlacement);
			});
		}

		// Stop vioeo in bootstrapModalDialog
		if ($('.modal').length) {
			for (var i = 0; i < $('.modal').length; i++) {
				let modalItem = $($('.modal')[i]);

				modalItem.on('hidden.bs.modal', $.proxy(function () {
					let activeModal = $(this),
						rdVideoInside = activeModal.find('video'),
						youTubeVideoInside = activeModal.find('iframe');

					if (rdVideoInside.length) {
						rdVideoInside[0].pause();
					}

					if (youTubeVideoInside.length) {
						let videoUrl = youTubeVideoInside.attr('src');

						youTubeVideoInside
							.attr('src', '')
							.attr('src', videoUrl);
					}
				}, modalItem));
			}
		}

		// Popovers
		if ($('[data-toggle="popover"]').length) {
			if (window.innerWidth < 767) {
				$('[data-toggle="popover"]').attr('data-placement', 'bottom');
				$('[data-toggle="popover"]').popover();
			}
			else {
				$('[data-toggle="popover"]').popover();
			}
		}

		// Bootstrap Buttons
		if ($('.btn-stateful').length) {
			$($('.btn-stateful')).on('click', function () {
				let statefulButtonLoading = $(this).button('loading');

				setTimeout(function () {
					statefulButtonLoading.button('reset');
				}, 2000);
			});
		}

		// Bootstrap tabs
		if ($(".tabs-custom").length) {
			for (var i = 0; i < $(".tabs-custom").length; i++) {
				let bootstrapTabsItem = $($(".tabs-custom")[i]);

				//If have slick carousel inside tab - resize slick carousel on click
				if (bootstrapTabsItem.find('.slick-slider').length) {
					bootstrapTabsItem.find('.tabs-custom-list > li > a').on('click', $.proxy(function () {
						let $this = $(this);
						let setTimeOutTime = isNoviBuilder ? 1500 : 300;

						setTimeout(function () {
							$this.find('.tab-content .tab-pane.active .slick-slider').slick('setPosition');
						}, setTimeOutTime);
					}, bootstrapTabsItem));
				}
			}
		}

		// Copyright Year (Evaluates correct copyright year)
		if (plugins.copyrightYear.length) {
			plugins.copyrightYear.text(initialDate.getFullYear());
		}

		// Google maps
		if (plugins.maps.length) {
			lazyInit(plugins.maps, initMaps);
		}

		// Add custom styling options for input[type="radio"]
		if (plugins.radio.length) {
			for (var i = 0; i < plugins.radio.length; i++) {
				$(plugins.radio[i]).addClass("radio-custom").after("<span class='radio-custom-dummy'></span>");
			}
		}

		// Add custom styling options for input[type="checkbox"]
		if (plugins.checkbox.length) {
			for (var i = 0; i < plugins.checkbox.length; i++) {
				$(plugins.checkbox[i]).addClass("checkbox-custom").after("<span class='checkbox-custom-dummy'></span>");
			}
		}

		// UI To Top
		if (isDesktop && !isNoviBuilder) {
			// $().UItoTop({
			// 	easingType: 'easeOutQuad',
			// 	containerClass: 'ui-to-top fa fa-angle-up'
			// });
		}

		// RD Navbar
		if ($(".rd-navbar").length) {
			//	debugger;
			let
				navbar = $(".rd-navbar"),
				aliases = { '-': 0, '-sm-': 576, '-md-': 768, '-lg-': 992, '-xl-': 1200, '-xxl-': 1600 },
				responsive = {};

			for (let alias in aliases) {
				let link = responsive[aliases[alias]] = {};
				if (navbar.attr('data' + alias + 'layout')) link.layout = navbar.attr('data' + alias + 'layout');
				if (navbar.attr('data' + alias + 'device-layout')) link.deviceLayout = navbar.attr('data' + alias + 'device-layout');
				if (navbar.attr('data' + alias + 'hover-on')) link.focusOnHover = navbar.attr('data' + alias + 'hover-on') === 'true';
				if (navbar.attr('data' + alias + 'auto-height')) link.autoHeight = navbar.attr('data' + alias + 'auto-height') === 'true';
				if (navbar.attr('data' + alias + 'stick-up-offset')) link.stickUpOffset = navbar.attr('data' + alias + 'stick-up-offset');
				if (navbar.attr('data' + alias + 'stick-up')) link.stickUp = navbar.attr('data' + alias + 'stick-up') === 'true';
				if (isNoviBuilder) link.stickUp = false;
				else if (navbar.attr('data' + alias + 'stick-up')) link.stickUp = navbar.attr('data' + alias + 'stick-up') === 'true';
			}

			navbar.RDNavbar({
				anchorNav: !isNoviBuilder,
				stickUpClone: (plugins.rdNavbar.attr("data-stick-up-clone") && !isNoviBuilder) ? plugins.rdNavbar.attr("data-stick-up-clone") === 'true' : false,
				responsive: responsive,
				callbacks: {
					onStuck: function () {
						let navbarSearch = this.$element.find('.rd-search input');

						if (navbarSearch) {
							navbarSearch.val('').trigger('propertychange');
						}
					},
					onDropdownOver: function () {
						return !isNoviBuilder;
					},
					onUnstuck: function () {
						if (this.$clone === null)
							return;

						let navbarSearch = this.$clone.find('.rd-search input');

						if (navbarSearch) {
							navbarSearch.val('').trigger('propertychange');
							navbarSearch.trigger('blur');
						}

					}
				}
			});
		}

		// RD Search
		if ($(".rd-search").length || $('.rd-search-results')) {
			var handler = "bat/rd-search.php";
			let defaultTemplate = '<h6 class="search-title"><a target="_top" href="#{href}" class="search-link">#{title}</a></h6>' +
				'<p>...#{token}...</p>' +
				'<p class="match"><em>Terms matched: #{count} - URL: #{href}</em></p>';
			let defaultFilter = '*.html';

			if ($(".rd-search").length) {
				for (var i = 0; i < $(".rd-search").length; i++) {
					var searchItem = $($(".rd-search")[i]),
						options = {
							element: searchItem,
							filter: (searchItem.attr('data-search-filter')) ? searchItem.attr('data-search-filter') : defaultFilter,
							template: (searchItem.attr('data-search-template')) ? searchItem.attr('data-search-template') : defaultTemplate,
							live: (searchItem.attr('data-search-live')) ? searchItem.attr('data-search-live') : false,
							liveCount: (searchItem.attr('data-search-live-count')) ? parseInt(searchItem.attr('data-search-live'), 10) : 4,
							current: 0, processed: 0, timer: {}
						};

					let $toggle = $('.rd-navbar-search-toggle');
					if ($toggle.length) {
						$toggle.on('click', (function (searchItem) {
							return function () {
								if (!($(this).hasClass('active'))) {
									searchItem.find('input').val('').trigger('propertychange');
								}
							};
						})(searchItem));
					}

					if (options.live) {
						var clearHandler = false;

						searchItem.find('input').on("input propertychange", $.proxy(function () {
							this.term = this.element.find('input').val().trim();
							this.spin = this.element.find('.input-group-addon');

							clearTimeout(this.timer);

							if (this.term.length > 2) {
								this.timer = setTimeout(liveSearch(this), 200);

								if (clearHandler === false) {
									clearHandler = true;

									$body.on("click", function (e) {
										if ($(e.toElement).parents('.rd-search').length === 0) {
											$('#rd-search-results-live').addClass('cleared').html('');
										}
									});
								}

							} else if (this.term.length === 0) {
								$('#' + this.live).addClass('cleared').html('');
							}
						}, options, this));
					}

					searchItem.submit($.proxy(function () {
						$('<input />').attr('type', 'hidden')
							.attr('name', "filter")
							.attr('value', this.filter)
							.appendTo(this.element);
						return true;
					}, options, this));
				}
			}

			if ($('.rd-search-results').length) {
				let regExp = /\?.*s=([^&]+)\&filter=([^&]+)/g;
				let match = regExp.exec(location.search);

				if (match !== null) {
					$.get(handler, {
						s: decodeURI(match[1]),
						dataType: "html",
						filter: match[2],
						template: defaultTemplate,
						live: ''
					}, function (data) {
						$('.rd-search-results').html(data);
					});
				}
			}
		}

		// Add class in viewport
		if ($('.view-animate').length) {
			for (var i = 0; i < $('.view-animate').length; i++) {
				let $view = $($('.view-animate')[i]).not('.active');
				$document.on("scroll", $.proxy(function () {
					if (isScrolledIntoView(this)) {
						this.addClass("active");
					}
				}, $view))
					.trigger("scroll");
			}
		}



		// WOW
		if ($(".wow").length && !isNoviBuilder && isDesktop) {
			new WOW().init();
		}

		// RD Input Label
		// if (plugins.rdInputLabel.length) {
		// 	plugins.rdInputLabel.RDInputLabel();
		// }

		// Regula
		// if ($("[data-constraints]").length) {
		// 	attachFormValidator($("[data-constraints]"));
		// }

		// MailChimp Ajax subscription
		if (plugins.mailchimp.length) {
			for (i = 0; i < plugins.mailchimp.length; i++) {
				let $mailchimpItem = $(plugins.mailchimp[i]),
					$email = $mailchimpItem.find('input[type="email"]');

				// Required by MailChimp
				$mailchimpItem.attr('novalidate', 'true');
				$email.attr('name', 'EMAIL');

				$mailchimpItem.on('submit', $.proxy(function ($email, event) {
					event.preventDefault();

					let $this = this;

					let data = {},
						url = $this.attr('action').replace('/post?', '/post-json?').concat('&c=?'),
						dataArray = $this.serializeArray(),
						$output = $("#" + $this.attr("data-form-output"));

					for (i = 0; i < dataArray.length; i++) {
						data[dataArray[i].name] = dataArray[i].value;
					}

					$.ajax({
						data: data,
						url: url,
						dataType: 'jsonp',
						error: function (resp, text) {
							$output.html('Server error: ' + text);

							setTimeout(function () {
								$output.removeClass("active");
							}, 4000);
						},
						success: function (resp) {
							$output.html(resp.msg).addClass('active');
							$email[0].value = '';
							let $label = $('[for="' + $email.attr('id') + '"]');
							if ($label.length) $label.removeClass('focus not-empty');

							setTimeout(function () {
								$output.removeClass("active");
							}, 6000);
						},
						beforeSend: function (data) {
							let isNoviBuilder = window.xMode;

							let isValidated = (function () {
								let results, errors = 0;
								let elements = $this.find('[data-constraints]');
								let captcha = null;
								if (elements.length) {
									for (let j = 0; j < elements.length; j++) {

										let $input = $(elements[j]);
										if ((results = $input.regula('validate')).length) {
											for (let k = 0; k < results.length; k++) {
												errors++;
												$input.siblings(".form-validation").text(results[k].message).parent().addClass("has-error");
											}
										} else {
											$input.siblings(".form-validation").text("").parent().removeClass("has-error");
										}
									}

									if (captcha) {
										if (captcha.length) {
											return validateReCaptcha(captcha) && errors === 0;
										}
									}

									return errors === 0;
								}
								return true;
							})();

							// Stop request if builder or inputs are invalide
							if (isNoviBuilder || !isValidated)
								return false;

							$output.html('Submitting...').addClass('active');
						}
					});

					return false;
				}, $mailchimpItem, $email));
			}
		}

		// Campaign Monitor ajax subscription
		if (plugins.campaignMonitor.length) {
			for (i = 0; i < plugins.campaignMonitor.length; i++) {
				let $campaignItem = $(plugins.campaignMonitor[i]);

				$campaignItem.on('submit', $.proxy(function (e) {
					let data = {},
						url = this.attr('action'),
						dataArray = this.serializeArray(),
						$output = $("#" + plugins.campaignMonitor.attr("data-form-output")),
						$this = $(this);

					for (i = 0; i < dataArray.length; i++) {
						data[dataArray[i].name] = dataArray[i].value;
					}

					$.ajax({
						data: data,
						url: url,
						dataType: 'jsonp',
						error: function (resp, text) {
							$output.html('Server error: ' + text);

							setTimeout(function () {
								$output.removeClass("active");
							}, 4000);
						},
						success: function (resp) {
							$output.html(resp.Message).addClass('active');

							setTimeout(function () {
								$output.removeClass("active");
							}, 6000);
						},
						beforeSend: function (data) {
							// Stop request if builder or inputs are invalide
							if (isNoviBuilder || !isValidated($this.find('[data-constraints]')))
								return false;

							$output.html('Submitting...').addClass('active');
						}
					});

					// Clear inputs after submit
					let inputs = $this[0].getElementsByTagName('input');
					for (var i = 0; i < inputs.length; i++) {
						inputs[i].value = '';
						let label = document.querySelector('[for="' + inputs[i].getAttribute('id') + '"]');
						if (label) label.classList.remove('focus', 'not-empty');
					}

					return false;
				}, $campaignItem));
			}
		}

		// RD Mailform
		// if (plugins.rdMailForm.length) {
		// 	var i, j, k,
		// 		msg = {
		// 			'MF000': 'Successfully sent!',
		// 			'MF001': 'Recipients are not set!',
		// 			'MF002': 'Form will not work locally!',
		// 			'MF003': 'Please, define email field in your form!',
		// 			'MF004': 'Please, define type of your form!',
		// 			'MF254': 'Something went wrong with PHPMailer!',
		// 			'MF255': 'Aw, snap! Something went wrong.'
		// 		};

		// 	for (i = 0; i < plugins.rdMailForm.length; i++) {
		// 		var $form = $(plugins.rdMailForm[i]),
		// 			formHasCaptcha = false;

		// 		$form.attr('novalidate', 'novalidate').ajaxForm({
		// 			data: {
		// 				"form-type": $form.attr("data-form-type") || "contact",
		// 				"counter": i
		// 			},
		// 			beforeSubmit: function (arr, $form, options) {
		// 				if (isNoviBuilder)
		// 					return;

		// 				let form = $(plugins.rdMailForm[this.extraData.counter]),
		// 					inputs = form.find("[data-constraints]"),
		// 					output = $("#" + form.attr("data-form-output")),
		// 					captcha = form.find('.recaptcha'),
		// 					captchaFlag = true;

		// 				output.removeClass("active error success");

		// 				if (isValidated(inputs, captcha)) {

		// 					// veify reCaptcha
		// 					if (captcha.length) {
		// 						let captchaToken = captcha.find('.g-recaptcha-response').val(),
		// 							captchaMsg = {
		// 								'CPT001': 'Please, setup you "site key" and "secret key" of reCaptcha',
		// 								'CPT002': 'Something wrong with google reCaptcha'
		// 							};

		// 						formHasCaptcha = true;

		// 						$.ajax({
		// 							method: "POST",
		// 							url: "bat/reCaptcha.php",
		// 							data: { 'g-recaptcha-response': captchaToken },
		// 							async: false
		// 						})
		// 							.done(function (responceCode) {
		// 								if (responceCode !== 'CPT000') {
		// 									if (output.hasClass("snackbars")) {
		// 										output.html('<p><span class="icon text-middle mdi mdi-check icon-xxs"></span><span>' + captchaMsg[responceCode] + '</span></p>');

		// 										setTimeout(function () {
		// 											output.removeClass("active");
		// 										}, 3500);

		// 										captchaFlag = false;
		// 									} else {
		// 										output.html(captchaMsg[responceCode]);
		// 									}

		// 									output.addClass("active");
		// 								}
		// 							});
		// 					}

		// 					if (!captchaFlag) {
		// 						return false;
		// 					}

		// 					form.addClass('form-in-process');

		// 					if (output.hasClass("snackbars")) {
		// 						output.html('<p><span class="icon text-middle fa fa-circle-o-notch fa-spin icon-xxs"></span><span>Sending</span></p>');
		// 						output.addClass("active");
		// 					}
		// 				} else {
		// 					return false;
		// 				}
		// 			},
		// 			error: function (result) {
		// 				if (isNoviBuilder)
		// 					return;

		// 				let output = $("#" + $(plugins.rdMailForm[this.extraData.counter]).attr("data-form-output")),
		// 					form = $(plugins.rdMailForm[this.extraData.counter]);

		// 				output.text(msg[result]);
		// 				form.removeClass('form-in-process');

		// 				if (formHasCaptcha) {
		// 					grecaptcha.reset();
		// 				}
		// 			},
		// 			success: function (result) {
		// 				if (isNoviBuilder)
		// 					return;

		// 				let form = $(plugins.rdMailForm[this.extraData.counter]),
		// 					output = $("#" + form.attr("data-form-output")),
		// 					select = form.find('select');

		// 				form
		// 					.addClass('success')
		// 					.removeClass('form-in-process');

		// 				if (formHasCaptcha) {
		// 					grecaptcha.reset();
		// 				}

		// 				result = result.length === 5 ? result : 'MF255';
		// 				output.text(msg[result]);

		// 				if (result === "MF000") {
		// 					if (output.hasClass("snackbars")) {
		// 						output.html('<p><span class="icon text-middle mdi mdi-check icon-xxs"></span><span>' + msg[result] + '</span></p>');
		// 					} else {
		// 						output.addClass("active success");
		// 					}
		// 				} else {
		// 					if (output.hasClass("snackbars")) {
		// 						output.html(' <p class="snackbars-left"><span class="icon icon-xxs mdi mdi-alert-outline text-middle"></span><span>' + msg[result] + '</span></p>');
		// 					} else {
		// 						output.addClass("active error");
		// 					}
		// 				}

		// 				form.clearForm();

		// 				if (select.length) {
		// 					select.select2("val", "");
		// 				}

		// 				form.find('input, textarea').trigger('blur');

		// 				setTimeout(function () {
		// 					output.removeClass("active error success");
		// 					form.removeClass('success');
		// 				}, 3500);
		// 			}
		// 		});
		// 	}
		// }

		// jQuery Count To
		// if ($(".counter").length) {
		// 	debugger;

		// }

		// TimeCircles
		if ($('.DateCountdown').length) {
			for (var i = 0; i < $('.DateCountdown').length; i++) {
				var
					dateCountdownItem = $($('.DateCountdown')[i]),
					countdownRender = function () {
						dateCountdownItem.TimeCircles({
							time: { Seconds: { show: !(window.innerWidth < 768) } }
						}).rebuild();
					};

				dateCountdownItem.TimeCircles({
					color: dateCountdownItem.attr("data-color") ? dateCountdownItem.attr("data-color") : "rgba(247, 247, 247, 1)",
					animation: "smooth",
					bg_width: dateCountdownItem.attr("data-bg-width") ? dateCountdownItem.attr("data-bg-width") : 0.6,
					circle_bg_color: dateCountdownItem.attr("data-bg") ? dateCountdownItem.attr("data-bg") : "rgba(0, 0, 0, 1)",
					fg_width: dateCountdownItem.attr("data-width") ? dateCountdownItem.attr("data-width") : 0.03,
					time: {
						Days: {
							text: "Days",
							show: true,
							color: dateCountdownItem.attr("data-color") ? dateCountdownItem.attr("data-color") : "#f9f9f9"
						},
						Hours: {
							text: "Hours",
							show: true,
							color: dateCountdownItem.attr("data-color") ? dateCountdownItem.attr("data-color") : "#f9f9f9"
						},
						Minutes: {
							text: "Minutes",
							show: true,
							color: dateCountdownItem.attr("data-color") ? dateCountdownItem.attr("data-color") : "#f9f9f9"
						},
						Seconds: {
							text: "Seconds",
							show: false,
							color: dateCountdownItem.attr("data-color") ? dateCountdownItem.attr("data-color") : "#f9f9f9"
						}
					}
				});

				countdownRender();
				window.addEventListener('resize', countdownRender);
			}
		}

		// Wide/Boxed Layout Toggle
		if ($(".layout-toggle").length) {
			for (var i = 0; i < $(".layout-toggle").length; i++) {
				let $layoutToggleElement = $($(".layout-toggle")[i]);

				$layoutToggleElement.on('click', function () {
					sessionStorage.setItem('pageLayoutBoxed', !(sessionStorage.getItem('pageLayoutBoxed') === "true"));
					$html.toggleClass('boxed');
					$window.trigger('resize');
				});
			}

			if (sessionStorage.getItem('pageLayoutBoxed') === "true") {
				$(".layout-toggle").attr('checked', true);
				$html.addClass('boxed');
				$window.trigger('resize');
			}

			let themeResetButton = document.querySelectorAll('[data-theme-reset]');
			if (themeResetButton) {
				for (var z = 0; z < themeResetButton.length; z++) {
					themeResetButton[z].addEventListener('click', function () {
						sessionStorage.setItem('pageLayoutBoxed', false);
						$(".layout-toggle").attr('checked', false);
						$html.removeClass('boxed');
						$window.trigger('resize');
					});
				}
			}
		}

		// Select2
		// if ($("select").length) {
		// 	var i;
		// 	for (i = 0; i < $("select").length; i++) {
		// 		let select = $($("select")[i]),
		// 			selectStyle = 'html-' + select.attr('data-style') + '-select';
		// 		$html.addClass(selectStyle);

		// 		select.select2({
		// 			placeholder: select.attr("data-placeholder") ? select.attr("data-placeholder") : false,
		// 			minimumResultsForSearch: select.attr("data-minimum-results-search") ? select.attr("data-minimum-results-search") : -1,
		// 			maximumSelectionSize: 3
		// 		});
		// 	}
		// }

		// Stepper
		// if ($("input[type='number']").length) {
		// 	$("input[type='number']").stepper({
		// 		labels: {
		// 			up: "",
		// 			down: ""
		// 		}
		// 	});
		// }

		//RD Range
		if ($('.rd-range').length && !isNoviBuilder) {
			$('.rd-range').RDRange({
				callbacks: {
					onChange: function () {
						let $inputs = $('.rd-range-input-value-1, .rd-range-input-value-2');

						for (let z = 0; z < $inputs.length; z++) {

							if (isDesktop) {
								$inputs[z].style.width = ($inputs[z].value.length + 1) * 1.15 + 'ch';
							}
						}
					},
				}
			});
		}

		// Radio Panel
		if ($('.radio-panel .radio-inline')) {
			for (var i = 0; i < $('.radio-panel .radio-inline').length; i++) {
				var $element = $($('.radio-panel .radio-inline')[i]);
				$element.on('click', function () {
					$('.radio-panel .radio-inline').removeClass('active');
					$(this).addClass('active');
				});
			}
		}


		function multitoggles() { var t = t || {}; function e(t) { this.node = t; } t = { attrToggle: t.attrToggle || "data-multitoggle", attrBlur: t.attrBlur || "data-multitoggle-blur", attrIsolate: t.attrIsolate || "data-multitoggle-isolate" }, e.prototype.init = function () { this.selectorTarget = this.node.getAttribute(t.attrToggle), this.selectorGroup = "[" + t.attrToggle + '="' + this.selectorTarget + '"]', this.selectorBlur = this.node.getAttribute(t.attrBlur), this.isolate = this.node.hasAttribute(t.attrIsolate), this.nodesTarget = document.querySelectorAll(this.selectorTarget), this.nodesGroup = document.querySelectorAll(this.selectorGroup), this.nodesBlur = document.querySelectorAll(this.selectorBlur), this.nodesIsolate = document.querySelectorAll("[" + t.attrIsolate + "]"); }, e.prototype.checkBlurContain = function (t) { for (var e = !1, o = 0; o < this.nodesBlur.length; o++)e = this.nodesBlur[o].contains(t) || e; return e; }, e.prototype.checkToggleTarget = function (e) { return !e.hasAttribute(t.attrToggle) || this.selectorTarget === e.getAttribute(t.attrToggle); }; for (var o = document.querySelectorAll("[" + t.attrToggle + "]"), r = [], l = 0; l < o.length; l++) { let s = new e(o[l]); s.init(), r.push(s); } for (l = 0; l < r.length; l++)r[l].node.addEventListener("click", function (t) { return function () { for (var e = 0; e < t.nodesTarget.length; e++)t.nodesTarget[e].classList.toggle("active"); for (e = 0; e < t.nodesGroup.length; e++)t.nodesGroup[e].classList.toggle("active"); }; }(r[l])), document.addEventListener("click", function (t) { return function () { if (t.selectorBlur && !t.checkBlurContain(event.target)) { for (var e = 0; e < t.nodesTarget.length; e++)t.nodesTarget[e].classList.remove("active"); for (e = 0; e < t.nodesGroup.length; e++)t.nodesGroup[e].classList.remove("active"); } if (t.isolate && !t.checkToggleTarget(event.target)) { for (e = 0; e < t.nodesTarget.length; e++)t.nodesTarget[e].classList.remove("active"); for (e = 0; e < t.nodesGroup.length; e++)t.nodesGroup[e].classList.remove("active"); } }; }(r[l])); }

		// Multitoggles
		if (document.querySelectorAll('[data-multitoggle]').length) {
			multitoggles();
		}

		// Hover groups
		for (var i = 0; i < document.querySelectorAll('[data-hover-group]').length; i++) {
			let hel = document.querySelectorAll('[data-hover-group]')[i];

			hel.addEventListener('mouseenter', function (event) {
				let hoverGroupName = event.target.getAttribute('data-hover-group'),
					hoverGroup = document.querySelectorAll('[data-hover-group="' + hoverGroupName + '"]');

				for (let e = 0; e < hoverGroup.length; e++) hoverGroup[e].classList.add('active');
			});

			hel.addEventListener('mouseleave', function (event) {
				let hoverGroupName = event.target.getAttribute('data-hover-group'),
					hoverGroup = document.querySelectorAll('[data-hover-group="' + hoverGroupName + '"]');

				for (let e = 0; e < hoverGroup.length; e++) hoverGroup[e].classList.remove('active');
			});
		}

		// Vide
		if (plugins.vide.length) {
			for (var i = 0; i < plugins.vide.length; i++) {
				var $element = $(plugins.vide[i]),
					options = $element.data('vide-options'),
					path = $element.data('vide-bg');

				$element.vide(path, options);

				let videObj = $element.data('vide').getVideoObject();

				if (isNoviBuilder) {
					videObj.pause();
				} else {
					document.addEventListener('scroll', function ($element, videObj) {
						return function () {
							if (isScrolledIntoView($element)) videObj.play();
							else videObj.pause();
						};
					}($element, videObj));
				}
			}
		}

		// Vide Addon
		if (!isNoviBuilder) {
			for (var i = 0; i < plugins.videoTriggers.length; i++) {
				let videoTrigger = $(plugins.videoTriggers[i]),
					bgVideoObj = $(videoTrigger.attr('data-video-trigger')).data("vide").getVideoObject(),
					relatedModal = $(videoTrigger.attr('data-target')),
					modalVideoObj = relatedModal.find('video')[0];

				relatedModal.on('show.bs.modal', (function (bgVideoObj) {
					return function () {
						bgVideoObj.pause();
					};
				})(bgVideoObj));

				relatedModal.on('shown.bs.modal', (function (modalVideoObj) {
					return function () {
						modalVideoObj.play();
					};
				})(modalVideoObj));

				relatedModal.on('hide.bs.modal', (function (bgVideoObj, modalVideoObj) {
					return function () {
						modalVideoObj.pause();
						modalVideoObj.currentTime = 0;
						bgVideoObj.play();
					};
				})(bgVideoObj, modalVideoObj));
			}
		}

		// Initialize before-after image plugin
		if ($(".twentytwenty-container").length) {
			for (var i = 0; i < $(".twentytwenty-container").length; i++) {
				let $item = $($(".twentytwenty-container")[i]);
				$item.twentytwenty({
					default_offset_pct: $item.attr('data-offset'),
					orientation: $item.attr('data-orientation')
				});
			}
		}
	});
}